// Who may authorize an RPO (owner's decisions; the backend checks the same in authorizeRPO):
// - HOTFIX 2026-10-29: Prashant (2), Ankit (6) and Narender (54), for every vendor.
// - HOTFIX 2026-11-02: Amrik (29) too, for the subsidiaries The Home Studio (vendor 7) and
//   Krishna Enterprises (vendor 12) only.
const APPROVER_IDS = [2, 6, 54];
const SUBSIDIARY_APPROVER_ID = 29;
const SUBSIDIARY_VENDOR_IDS = [7, 12];

export const canAuthorizeRPO = (userId, vendorId) =>
  APPROVER_IDS.includes(userId) ||
  (userId === SUBSIDIARY_APPROVER_ID &&
    SUBSIDIARY_VENDOR_IDS.includes(+vendorId));
